import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="slot-picker"
export default class extends Controller {
  static targets = ['slotSelect']
  static values = {
    availableSlots: Array
  }

  setSlots(event) {
    this.resetSlotSelectOptions()

    const selectedDate = event.target.value
    if (!selectedDate) return

    const [, slots] = this.availableSlotsValue.find(([date]) => date === selectedDate)
    slots.forEach(([text, value]) => {
      this.appendSlotOption(text, value)
    })
  }

  resetSlotSelectOptions() {
    const options = Array.from(this.slotSelectTarget.options)
    options.forEach((opt) => opt.remove())

    this.appendSlotOption('', '')
  }

  appendSlotOption(text, value) {
    this.slotSelectTarget.add(new Option(text, value), null)
  }
}
